export default "__VITE_ASSET__gBNz1rn7__"